const orderSettings = {
  orderIdType: "internal",
  receiptType: "email",
};

export default orderSettings;
